import script from "./InvoiceDownstreamAllocationDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./InvoiceDownstreamAllocationDialog.vue?vue&type=script&setup=true&lang=js"

import "./InvoiceDownstreamAllocationDialog.vue?vue&type=style&index=0&id=5b102e04&scoped=true&lang=css"
import "./InvoiceDownstreamAllocationDialog.vue?vue&type=style&index=1&id=5b102e04&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b102e04"]])

export default __exports__